import { buildOptions, getEndPoint } from '../../../utils/api-call';
import constants from './constants';
import { makeCall } from '../../../utils/request';

const resendEmail = ({commit, state, dispatch}, data) => {
  return new Promise((resolve, reject) => {
    makeCall(getEndPoint().emailHistory.resendEmail, buildOptions('POST', data))
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
};

export default {
  [constants.ACTION_RESEND_EMAIL]: resendEmail
};



// WEBPACK FOOTER //
// ./src/store/modules/emailHistory/actions.js